import styled from "styled-components";

export const Wrapper = styled.button`
    background-color: white;
    color: var(--background-color);
    font-size: 1.2rem;
    padding: 0.5em 1em;
    cursor: pointer;
    border-radius: 10px;

    :hover {
        background-color: hsl(0, 0%, 70%);
    }
`
